const POST = 'POST';
const GET = 'GET';

const checkStatus = (response: Response): Promise<Response> => {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(new Error(response.statusText));
  }
};

const getJsonHeaders = (
  headers: Record<string, string> = {}
): Pick<RequestInit, 'headers' | 'credentials'> => ({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    ...headers,
  },
  credentials: 'same-origin',
});

const getMethod = (methodValue: string): Pick<RequestInit, 'method'> => {
  return {
    method: methodValue,
  };
};

const getBody = <T>(requestParams: T): Pick<RequestInit, 'body'> => {
  return {
    body: JSON.stringify(requestParams),
  };
};

const request = <T>(url: string, params: RequestInit): Promise<T> =>
  fetch(url, params)
    .then(checkStatus)
    .then((response) => response.json().catch(() => {}));

const get = <T>(
  url: string,
  headers: Record<string, string> = {}
): Promise<T> => {
  const getParams = { ...getMethod(GET), ...getJsonHeaders(headers) };

  return request<T>(url, getParams);
};

const post = <T, B>(
  url: string,
  params: B,
  headers: Record<string, string> = {}
): Promise<T> => {
  const postParams = {
    ...getMethod(POST),
    ...getBody<B>(params),
    ...getJsonHeaders(headers),
  };

  return request<T>(url, postParams);
};

export { get, post };
